import { GET_DASHBOARD_DATA_SUCCESS, GET_REGIONAL_ADMIN_DASHBOARD_DATA_SUCCESS, GET_ADMIN_DASHBOARD_DATA_SUCCESS, SAVE_REMINDER_CONFIG_ADMIN_SUCCESS, SAVE_REMINDER_CONFIG_REGIONAL_SUCCESS, GET_COUNTRY_MODULE_DATA_SUCCESS, UNMOUNT_DASHBOARD_DATA_SUCCESS, GET_DASHBOARD_DATA_OFFLINE_SUCCESS } from '../constants/constants';

export function UserDashboardReducer(state = { userDashboard: {}, userAdminDashboard: {}, userReionalAdminDashboard: {} }, action: any) {
  switch (action.type) {
    case GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        userDashboard: action.payload.data
      }
    case GET_DASHBOARD_DATA_OFFLINE_SUCCESS:
      console.log('GET_DASHBOARD_DATA_OFFLINE_SUCCESS', action.payload)
      return {
        ...state,
        userDashboard: action.payload
      }
    case GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        userAdminDashboard: action.payload.data.payload
      }
    case GET_REGIONAL_ADMIN_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        userReionalAdminDashboard: action.payload.data.payload
      }
    case SAVE_REMINDER_CONFIG_ADMIN_SUCCESS:
      return {
        ...state,
        userAdminDashboard: action.payload.userAdminDashboard
      }
    case SAVE_REMINDER_CONFIG_REGIONAL_SUCCESS:
      return {
        ...state,
        userReionalAdminDashboard: action.payload.userReionalAdminDashboard
      }
    case GET_COUNTRY_MODULE_DATA_SUCCESS:
      return {
        ...state,
        countryModuleDetails: action.payload.data.payload
      }
    case UNMOUNT_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        userAdminDashboard: null,
        userReionalAdminDashboard: null
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer.userDashboard.tsx